"use strict"

class Toggle {

	constructor ( toggle, region ) {
		this.toggle = toggle
		this.region = region

		this.initRegion()
		this.initToggle()

	}

	/**
	 * @function _initRegion
	 * @desc Add a CSS class to hide the region which is controlled by the toggle button
	 */
	initRegion () {
		this.region.classList.add('is-closed')
	}

	/**
	 * @function _initToggle
	 * @desc Bind an event listener on the button and init the behaviours of the region and the button
	 */
	initToggle () {
		const toggle = this.toggle
		const region = this.region

		toggle.addEventListener( 'click', function () {
			if ( this.classList.contains('is-active') ) {
				this.classList.remove('is-active')
				this.setAttribute('aria-expanded', false)
				if ( toggle.dataset.opening )
					this.textContent = toggle.dataset.opening
				region.classList.add('is-closed')
			} else {
				this.classList.add('is-active')
				this.setAttribute('aria-expanded', true)
				if ( toggle.dataset.closing )
					this.textContent = toggle.dataset.closing
				region.classList.remove('is-closed')
			}
		} )
	}
}

export { Toggle }
